import React from "react";
import styles from "./ProgressBar.module.css";

function ProgressBar({fraction, total, showText = false}) {
  return (    
    <div className={styles.progressContainer}>
      <div className={styles.progressbar}>
        <span data-testid="progressbar" className={styles.progress} style={{width: parseInt((fraction / total)*100) + '%'}}></span>
      </div>
      {showText && <div data-testid="progresstext" className={styles.count + ' ft-14'}>{fraction} / {total}</div>}
    </div>
  );
}

export default ProgressBar;